import React, { useEffect } from "react";
import "../App.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Toast } from "react-bootstrap";
import Header from "../components/Header";
import Pricing from "./Pricing";
import Faqsection from "./Faqsection"
import { BiMessageRounded } from "react-icons/bi";
import { FaArrowRightLong } from "react-icons/fa6";
import Footer from "../components/Footer";
import Earnsection from "./Earnsection";

const HomePage = () => {
  let user = localStorage.getItem("user");
  const location = useLocation()
  const navigate = useNavigate()
  const queryParams = new URLSearchParams(location.search);
  console.log("🚀 ~ HomePage ~ user:", user);
  const scrollToPricing = queryParams.get('scroll');

  const toast = () => Toast("Hello!");

  const scrollToPricingSection = (scroll = true) => {
    const section = document.getElementById('pricing-section');
    if (scroll == true && section) {
      // Scroll to the section smoothly
      section.scrollIntoView({ behavior: 'smooth', block: "end" });
    }
  }

  useEffect(() => {
    const section = document.getElementById('pricing-section');
    if (scrollToPricing === 'true' && section) {
      setTimeout(() => {
        section.scrollIntoView({ behavior: 'smooth' });

        // Remove the scrollTopricing flag from the URL
        queryParams.delete('scroll');
        const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
        window.history.replaceState(null, '', newUrl);
      }, 100); // Adjust the delay as needed (e.g., 100ms)
    }
  }, []);


  return (
    <div className="home_page_mian_div">
      {/* {user && JSON.parse(localStorage.getItem("user"))?.name && (
        <h3 className="download_heading">
          Go to google extension for download
        </h3>
      )} */}
      <div className="bg-img-div">
        <Header />
        <div className="optimize_crm">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 my-auto">
                <div className="optimize_crm_content">
                  <h1 className="h1 text-lg-start text-center">
                    {/* Optimize CRM, Sales & Manage Leads with Teacher's <span>Aid</span> */}
                    Never lose a Lead, <br /> Message, or Sale <br /> On Skool again!
                  </h1>

                  <p className="py-4 pe-lg-2 text-lg-start text-center">
                    Mini Skool Messenger CRM that helps you manage your <br /> inbox, follow up with prospects, get more sales & build your <br /> community.</p>

                  <div className="button_content_box">
                    <div className="gradiant-bg-btn">
                      <button onClick={() => scrollToPricingSection()}>
                        <img src="/images/chrome-store.svg" alt="Chrome" />
                        Try today
                      </button>
                    </div>
                    <p className="pt-2 text-lg-start text-center">Teacher’s Aid turns conversations to conversions</p>
                  </div>
                </div>
                {user && user?.name ? (
                  <div>
                    <Link to="/login">
                      <button className="blue-btn me-2">Login</button>
                    </Link>
                    <button className="gray-btn">Try Now</button>
                  </div>
                ) : null}
              </div>
              <div className="col-lg-6">
                {/* <div className="img-right hero_Section_img">
                  <img
                    src="/images/Grid3.png"
                    alt="hero frame"
                    className="img-fluid"
                  />
                </div> */}
                <div className="optimize_video_box">
                  <iframe
                    src="https://www.youtube.com/embed/98-tPddG9VI?autoplay=1&loop=1&playlist=98-tPddG9VI&mute=1"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="encrypted-media; autoplay"
                    allowFullScreen
                  ></iframe>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Grid Sections 1 */}

      <div className="grid_sections">
        <div className="container">
          <div className="global-padding">
            <div className="row">
              <div className="col-lg-6 col-xl-7 my-auto">
                <div className="img-left">
                  <img src="/images/Grid1.png" alt="improving CRM" className="img-fluid" />
                </div>
              </div>
              <div className="col-lg-6 col-xl-5 my-auto">
                <div className="grid_content ps-lg-2">
                  <h2>Organize, Track, and Close Deals Faster with Teacher’s Aid</h2>
                  <p className="py-3">Teacher’s Aid makes it easy to manage your contacts, organize conversations, and never miss an opportunity to follow up.</p>
                  <div className="flex_grid_content_box">
                    <div className="grid_listbox_flexbox">
                      <div className="icon_box">
                        <p>1</p>
                      </div>
                      <div className="grid_flex_content">
                        <p>Organize your inbox with custom tags</p>
                        <span>Simplify your chats with label leads, follow-ups, and prospects for easy tracking so you always know where to focus next.</span>
                      </div>
                    </div>

                    <div className="grid_listbox_flexbox">
                      <div className="icon_box">
                        <p>2</p>
                      </div>
                      <div className="grid_flex_content">
                        <p>Add and View Notes</p>
                        <span>Keep track of every detail. Attach notes to conversations to remember important insights and next steps. Personalized follow-ups keep you prepared.</span>
                      </div>
                    </div>

                    <div className="grid_listbox_flexbox">
                      <div className="icon_box">
                        <p>3</p>
                      </div>
                      <div className="grid_flex_content">
                        <p>Set Smart Reminders</p>
                        <span>Create reminders for follow-ups and tasks so you’re always on schedule turning opportunities into results.</span>
                      </div>
                    </div>

                  </div>

                  <div className="white-bg-btn">
                    <button onClick={() => scrollToPricingSection()}>
                      <img src="/images/chrome-store.svg" alt="Chrome" />
                      Start Closing More Deals
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Grid Sections 2 */}

      <div className="grid_sections">
        <div className="container">
          <div className="global-padding">
            <div className="row">
              <div className="col-lg-6 col-xl-5 my-auto order-2 order-lg-first">
                <div className="grid_content pe-lg-5">
                  <h2>Teams love Teacher’s Aid</h2>
                  <p className="py-3">Everything your team needs to track, organize, and convert leads—without getting overwhelmed by complex tools.</p>
                  <div className="flex_grid_content_box">
                    <div className="grid_listbox_flexbox">
                      <div className="icon_box">
                        <p>1</p>
                      </div>
                      <div className="grid_flex_content">
                        <p>Stay on the same page, always.</p>
                        <span>Easily share tags, organize leads, and keep everyone on the same page with real-time updates across your team.</span>
                      </div>
                    </div>

                    <div className="grid_listbox_flexbox">
                      <div className="icon_box">
                        <p>2</p>
                      </div>
                      <div className="grid_flex_content">
                        <p>Keep teams organized and secure.</p>
                        <span>Assign role-based profiles and permissions to ensure every team member has access to the right tools and information—nothing more, nothing less.</span>
                      </div>
                    </div>
                  </div>

                  <div className="white-bg-btn">
                    <button onClick={() => scrollToPricingSection()}>
                      <img src="/images/chrome-store.svg" alt="Chrome" />
                      Invest in your team
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-xl-7 my-auto order-1 order-lg-last">
                <div className="img-right m-0 mb-lg-0 mb-5">
                  <img src="/images/Grid2.png" alt="collaborate" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Grid Sections 3 */}

      <div className="grid_sections">
        <div className="container">
          <div className="global-padding">
            <div className="row">
              <div className="col-lg-6 col-xl-7 my-auto">
                <div className="img-left">
                  <img src="/images/Grid3.png" alt="leads management" className="img-fluid" />
                </div>
              </div>
              <div className="col-lg-6 col-xl-5 my-auto">
                <div className="grid_content ps-lg-2">
                  <h2>Boost Your Sales with Automated Lead Tracking</h2>
                  <p className="py-3">Track every lead, set smart reminders, custom notes to ensure no opportunity is missed. Spend less time tracking and more time closing deals.</p>
                  <div className="flex_grid_content_box">
                    <div className="grid_listbox_flexbox">
                      <div className="icon_box">
                        <p>1</p>
                      </div>
                      <div className="grid_flex_content">
                        <p>Keep Every Lead on Your Radar</p>
                        <span>Track every interaction and see exactly where each lead stands in your sales pipeline. Stay organized and never lose sight of opportunities.</span>
                      </div>
                    </div>

                    <div className="grid_listbox_flexbox">
                      <div className="icon_box">
                        <p>2</p>
                      </div>
                      <div className="grid_flex_content">
                        <p>Keep teams organized and secure.</p>
                        <span>Set smart reminders to connect at the perfect time and close deals faster. Automate the busy work so you can focus on what matters most—growing your sales.</span>
                      </div>
                    </div>

                  </div>

                  <div className="white-bg-btn">
                    <button onClick={() => scrollToPricingSection()}>
                      <img src="/images/chrome-store.svg" alt="Chrome" />
                      Start growing your sales today
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-img-skool-section">
        {/* Skool Section  */}
        {/* <div className="skool_section">
          <div className="container">
            <div className="global-padding">
              <h2>
                Empowers you with seamless <span><img src="/images/skool.png" alt="skool" /></span> integration, helping <br /> you manage your community, CRM, sales, and leads—all <br /> organized, tracked, and always in sync.
              </h2>
            </div>
          </div>
        </div> */}

        {/* Cards Section */}

        <div className="cards_section">
          <div className="container">
            <div className="global-padding">
              <div className="heading_box">
                <h2>How Teacher’s Aid Makes Your Life Easier</h2>
                <p>Stay organized, boost productivity, and focus on what matters most.</p>
              </div>
              <div className="cards_grid_section">
                <div className="row">
                  <div className="col-lg-3 col-sm-6 mt-3 responsive-padding">
                    <div className="card">
                      {/* <div className="icon_box">
                        <BiMessageRounded />
                      </div> */}
                      <div className="icon_img">
                        <img src="/images/messages.png" alt="Conversations" />
                      </div>
                      <h6>
                      Stay on Top of Every Chat
                      </h6>
                      <p>Easily organize and tag conversations so you never miss a lead, message, or opportunity.</p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-6 mt-3 responsive-padding">
                    <div className="card">
                      {/* <div className="icon_box blue">
                        <img src="/images/clock.png" alt="clock" />
                      </div> */}
                      <div className="icon_img">
                        <img src="/images/clock-img.png" alt="Reminders" />
                      </div>
                      <h6>
                      Never Miss a Follow-Up Again
                      </h6>
                      <p>Set smart reminders for tasks and follow-ups to stay ahead and keep everything on track.</p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-6 mt-3 responsive-padding">
                    <div className="card">
                      {/* <div className="icon_box yellow">
                        <img src="/images/Huge-icon.png" alt="vector" />
                      </div> */}
                      <div className="icon_img">
                        <img src="/images/checkbox.png" alt="synchronization" />
                      </div>
                      <h6>
                      Start Fast, Work Faster
                      </h6>
                      <p>Assign roles and customize access to keep your team aligned, productive, and stress-free.</p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-6 mt-3 responsive-padding">
                    <div className="card">
                      {/* <div className="icon_box green">
                        <img src="/images/Vector.png" alt="vector" />
                      </div> */}
                      <div className="icon_img">
                        <img src="/images/vectors-img.png" alt="Setup" />
                      </div>
                      <h6>
                      Manage Your Conversations
                      </h6>
                      <p>Skip the learning curve with an intuitive setup that gets you up and running in minutes.</p>
                    </div>
                  </div>
                </div>

                <div className="gradiant-bg-btn">
                  <button onClick={() => scrollToPricingSection()}>
                    <img src="/images/chrome-store.svg" alt="Chrome" />
                    Start Closing More Deals
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="pricing-section">
        <Pricing />
      </div>

      <Faqsection scrollToPricingSection={scrollToPricingSection} />

      {/* Earn Section */}
      <Earnsection />
      <Footer />
    </div>
  );
};

export default HomePage;
